module.exports = __webpack_public_path__ + "img/initial-settings.b0ec068b.png";